module.exports = __webpack_public_path__ + "img/ticket_g.402ccba2.svg";